module.exports = __webpack_public_path__ + "img/project_map.9d84dcc7.png";